// Los links de las publicaciones con que el difusor cumplió un envío.
// Espejo de Backend/src/utils/urlsPost.js.

export const MAX_LINKS = 10;

// De qué red es un link, para mostrar su ícono y para avisar si se pegó el
// de otra red. Null si es otro sitio (la nota en la web del difusor).
const PLATAFORMAS = {
  instagram: ["instagram.com"],
  facebook: ["facebook.com", "fb.com", "fb.watch"],
  tiktok: ["tiktok.com"],
  twitter: ["twitter.com", "x.com"],
  spotify: ["spotify.com", "spotify.link"],
  youtube: ["youtube.com", "youtu.be"],
  twitch: ["twitch.tv"],
  kick: ["kick.com"],
};

export function plataformaDeUrl(valor) {
  let host;
  try {
    const texto = String(valor || "").trim();
    host = new URL(/^https?:\/\//i.test(texto) ? texto : `https://${texto}`)
      .hostname.toLowerCase();
  } catch (e) {
    return null;
  }
  for (const [plataforma, dominios] of Object.entries(PLATAFORMAS))
    if (dominios.some((d) => host === d || host.endsWith(`.${d}`)))
      return plataforma;
  return null;
}

// Si un link es de alguno de los canales que el equipo le aprobó al difusor
// para los envíos de 5 RC: en un sitio, el mismo dominio (o un subdominio);
// en una red, la misma red. Espejo de linkEsDeAlgunCanal en
// Backend/src/utils/canales5RC.js, que es el que decide.
export function linkEsDeAlgunCanal(link, canales = []) {
  const host = (valor) => {
    try {
      const texto = String(valor || "").trim();
      return new URL(/^https?:\/\//i.test(texto) ? texto : `https://${texto}`)
        .hostname.toLowerCase()
        .replace(/^www\./, "");
    } catch (e) {
      return null;
    }
  };
  const hostLink = host(link);
  if (!hostLink || !String(link).trim()) return false;
  const plataforma = plataformaDeUrl(link) || "sitio";
  return canales.some((canal) => {
    if (canal.plataforma !== plataforma) return false;
    if (plataforma !== "sitio") return true;
    const hostCanal = host(canal.url);
    return Boolean(hostCanal) && (hostLink === hostCanal || hostLink.endsWith(`.${hostCanal}`));
  });
}

// La lista que viene del servidor. Los envíos de antes del cambio solo traen
// `url_post`; y la columna JSON puede llegar como texto.
export function urlsDelPost(envio) {
  let urls = envio?.urls_post;
  if (typeof urls === "string") {
    try {
      urls = JSON.parse(urls);
    } catch (e) {
      urls = null;
    }
  }
  if (Array.isArray(urls) && urls.length > 0)
    return urls.filter((u) => typeof u === "string" && u);
  return envio?.url_post ? [envio.url_post] : [];
}

// Lo que hay en el portapapeles → un link, o null. Solo se acepta si es UN
// link suelto: al compartir, RadarFreim deja copiado el texto de la
// publicación (que trae el link de boletos o de la canción), y tomar un link
// de ahí sería registrar como "publicación" algo que no lo es.
export function linkDelPortapapeles(texto) {
  const limpio = String(texto || "").trim();
  if (!limpio || /\s/.test(limpio)) return null;
  const conProtocolo = /^https?:\/\//i.test(limpio)
    ? limpio
    : `https://${limpio}`;
  try {
    const url = new URL(conProtocolo);
    if (!url.hostname.includes(".")) return null;
    return url.toString();
  } catch (e) {
    return null;
  }
}
